import { Component, OnInit } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { Router } from '@angular/router';
import { ApiRegistryService } from '../../../services/api-registry.service';
import { ApiAuthService } from 'src/app/services/api-auth.service';
import { ApiParametrosService } from 'src/app/services/api-parametros.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

declare var $: any;
declare let Swal: any;
@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.css']
})
export class RegistroComponent implements OnInit {
  public ResponseCaptcha: boolean = false;
  public correo: boolean = true; //Controla el div con el mensaje de "Las contraseñas o correos no coinciden"
  public password: boolean = true; //Controla el div con el mensaje de "Las contraseñas o correos no coinciden"
  public valida: boolean = true; //Controla el div con el mensaje de "Campos Incompletos"
  public RFC: string = ''; //Poner clase is-invalid en caso de que el input este vacio
  public correo1: string = ''; //Poner clase is-invalid en caso de que el input este vacio
  public correo2: string = ''; //Poner clase is-invalid en caso de que el input este vacio
  public pass1: string = ''; //Poner clase is-invalid en caso de que el input este vacio
  public pass2: string = ''; //Poner clase is-invalid en caso de que el input este vacio
  public celular: string = ''; //Poner clase is-invalid en caso de que el input este vacio

  public errorRfc: string = ''; //Guardar el mensaje de error de campo sin completar
  public errorCorreo: string = ''; //Guardar el mensaje de error de campo sin completar
  public errorCorreoConf: string = ''; //Guardar el mensaje de error de campo sin completar
  public errorPass: string = ''; //Guardar el mensaje de error de campo sin completar
  public errorPassRep: string = ''; //Guardar el mensaje de error de campo sin completar
  public errorRegistro: string = ''; //Guardar el mensaje de error de campo sin completar
  public errorCelular: string = ''; // Guardar el mensaje de error de campo sin completar

  //BLOQUEA EDICION DE CAMPOS
  public login: boolean = false;
  //Patron que se ejecuta en el ingreso del email en el input
  emailPattern: any = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //rfcPattern: any = /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Z\d]{3})?$/;
  //Patron que se ejecuta en el ingreso del RFC en el input
  rfcPattern: any = /^([A-ZÑ&]{3,4})?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01]))?([A-Z\d]{2})([A\d])$/;
  tipo:string = '0';
  ///22/11/2022 asoledad
  vps_tipoTr:string = '5';
  edoRegistro:any = 1;
  //Creacion del FormGroup con sus determinados campos y sus validators.
  createFormGroup() {
    return new FormGroup({
      rfc: new FormControl('', [Validators.required, Validators.pattern(this.rfcPattern)]),
      correo: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
      correoconf: new FormControl('', Validators.required),
      password: new FormControl('', [Validators.required, Validators.minLength(8)]),
      passwordRepeat: new FormControl('', [Validators.required, Validators.minLength(8)]),
      celular: new FormControl('', [Validators.required, Validators.minLength(10)]),
    });
  }

  contactForm: FormGroup;
  constructor(private router: Router, private apiAuth: ApiAuthService , private apiRegistry: ApiRegistryService, private apiParam: ApiParametrosService)
  {

    this.contactForm = this.createFormGroup();
    let url = this.router.routerState.snapshot.url;
    console.log(url);
    this.edoRegistro = 1;
    if (url === '/registro/1') {
      this.tipo = '1';


    }else if (url === '/registro/0') {
      this.tipo = '0';
    }
  }

  ngOnInit() {

    this.edoRegistro = 1;

    if(this.tipo === "1"){
      $('#mod_procesando').modal('show');

      this.apiRegistry.getEdoRegistro(this.vps_tipoTr).subscribe(data => {
        setTimeout(() => {
            $('#mod_procesando').modal('hide');

          }, 400);

        if (data[0].success && data[0].info !== '{}' && data[0].info !== '[]') {

          this.edoRegistro = JSON.parse(data[0].info);

        } else {
          //this.errorRegistro = data[0].msgRespuesta;
          Swal.fire({
					  type: 'error',
					  title: 'Error...',
					  text: data[0].msgRespuesta,
					  showConfirmButton: true
					});

        }

      },
      error => {
        console.log('Error');
        //this.errorRegistro = 'Ha ocurrido un error al realizar el registro, comunicarse al Departamento de Sistemas.';
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
      }, 500);
      });

    }
  }

  //Funcion para el captcha
  resolved(captchaResponse: string) {

    if (isNullOrUndefined(captchaResponse)) {
      this.ResponseCaptcha = false;
    } else {
      this.ResponseCaptcha = true;
    }
  }

  onResetForm() {
    this.contactForm.reset();
  }



  //GAMORALES 05/09/2019
  //Realiza el preregistro de usuarios - GAMORALES 05/09/2019
  registrar() {
    let mensaje = this.tipo === '1'?'Personal de Honorarios':'Proveedor';

    if(this.validaCampos() && this.camposIguales()){
      Swal.fire({
        title: 'Registro de '+ mensaje,
        text: "¿Esta segur@ de realizar el Registro?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar'
      }).then((result) => {
        if (result.value) {


              $('#mod_procesando').modal('show');
              let RFC = this.contactForm.get('rfc').value;
              let correo = this.contactForm.get('correo').value;
              let password = this.contactForm.get('password').value;
              let celular = this.contactForm.get('celular').value;
              ///iDENTIFICAR SI ES PRESTADOR DE SERVICIOS
              let tipo = this.tipo;

              this.valida = true;
              //preRegistro => Realiza el preregistro del proveedor
              this.apiRegistry.preRegistro(RFC, correo, password, celular,tipo).subscribe(data => {
                if (data[0].success) {
                  this.apiParam.setDatosUsuario(correo, password);
                  //verificaCorreo => Envia correo de verificación de la cuenta.
                  /*this.apiAuth.verificaCorreo(correo).subscribe(data => {
                  });*/
                  setTimeout(() => {
                    $('#mod_procesando').modal('hide');
                    $('#success').modal('show');
                  }, 500);
                } else {

                  setTimeout(() => {
                    $('#mod_procesando').modal('hide');

                    Swal.fire({
                      type: 'error',
                      title: 'Error',
                      text: data[0].msgRespuesta,//'Ha ocurrido un error al realizar el registro,Recargue la página e intente nuevamente realizar el registro, en caso de persistir el error contactar a:\n Lic. María del Carmen Esparza Pérez,<br> Asistente del Departamento de Compras de la DGF<br> (449) 910 74 84 ext 32212<br> carmen.esparza@edu.uaa.mx',
                      showConfirmButton: true
                     });
                  }, 500);

                }
              },
              error => {
                console.log('Error');
                //this.errorRegistro = 'Ha ocurrido un error al realizar el registro,Recargue la página e intente nuevamente realizar el registro, en caso de persistir el error contactar a <br> Lic. María del Carmen Esparza Pérez,<br> Asistente del Departamento de Compras de la DGF<br> (449) 910 74 84 ext 32212<br> carmen.esparza@edu.uaa.mx';
                // 'Ha ocurrido un error al realizar el registro, comunicarse al Departamento de Sistemas.';
                setTimeout(() => {
                  $('#mod_procesando').modal('hide');
                  $('#error').modal('show');
              }, 500);
              });

        }///RESULTADO

        });
      }


  }

  siguiente() {
    this.router.navigate(['/home']);
  }

  //Validacion de campos completos
  validaCampos() {
    let bandValida = true;
    this.contactForm.controls.rfc.setValue(this.contactForm.get('rfc').value.toUpperCase());
    if(this.contactForm.controls.rfc.hasError('required')){
      bandValida = false;
      this.RFC = 'is-invalid';
      this.errorRfc = 'Campo sin completar';
    } else if(this.contactForm.controls.rfc.hasError('pattern')){
      bandValida = false;
      this.RFC = 'is-invalid';
      this.errorRfc = 'Formato RFC incorrecto';
    } else {
      this.errorRfc = '';
      this.RFC = '';
    }


    if(this.contactForm.controls.correo.hasError('required')) {
      bandValida = false;
      this.correo1 = 'is-invalid';
      this.errorCorreo = 'Campo sin completar';
    } else if(this.contactForm.controls.correo.hasError('pattern')) {
      bandValida = false;
      this.correo1 = 'is-invalid';
      this.errorCorreo = 'Formato correo incorrecto';
    } else {
      this.errorCorreo = '';
      this.correo1 = '';
    }


    if(this.contactForm.controls.correoconf.hasError('required')){
      bandValida = false;
      this.correo2 = 'is-invalid';
      this.errorCorreoConf = 'Campo sin completar';
    } else {
      this.errorCorreoConf = '';
      this.correo2 = '';
    }

    if(this.contactForm.controls.password.hasError('required')){
      bandValida = false;
      this.pass1 = 'is-invalid';
      this.errorPass = 'Campo sin completar';
    } else if (this.contactForm.controls.password.hasError('minlength')) {
      bandValida = false;
      this.pass1 = 'is-invalid';
      this.errorPass = 'La contraseña debe tener al menos 8 caracteres.';
    } else {
      this.errorPass = '';
      this.pass1 = '';
    }

    if(this.contactForm.controls.passwordRepeat.hasError('required')){
      bandValida = false;
      this.pass2 = 'is-invalid';
      this.errorPassRep = 'Campo sin completar';
    } else if (this.contactForm.controls.passwordRepeat.hasError('minlength')) {
      bandValida = false;
      this.pass2 = 'is-invalid';
      this.errorPassRep = 'La contraseña debe tener al menos 8 caracteres.';
    } else {
      this.errorPassRep = '';
      this.pass2 = '';
    }
    // Celular
    if(this.contactForm.controls.celular.hasError('required')){
      bandValida = false;
      this.celular = 'is-invalid';
      this.errorCelular = 'Campo sin completar';
    } else if (this.contactForm.controls.celular.hasError('minlength')) {
      bandValida = false;
      this.celular = 'is-invalid';
      this.errorCelular = 'Se requiere su número de celular a 10 dígitos.';
    } else {
      this.errorCelular = '';
      this.celular  = '';
    }

    if(!this.ResponseCaptcha) {
      bandValida = false;
      this.valida = false;
    } else {
      this.valida = true;
    }

    return bandValida;
  }

  //Revisa que los campos de correo y contraseña coincidan.
  camposIguales() {
    let bandValida = true;
    let correo = this.contactForm.get('correo').value;
    let correoConf = this.contactForm.get('correoconf').value;
    let password = this.contactForm.get('password').value;
    let passwordRepeat = this.contactForm.get('passwordRepeat').value;

    if (correo !== correoConf){
      bandValida = false;
      this.correo = false;
    } else {
      this.correo = true;
    }

    if (password !== passwordRepeat) {
      bandValida = false;
      this.password = false;
    } else {
      this.password = true;
    }

    return bandValida;
  }

  //Excluye caracteres especiales
  soloLetras(e) {
    var tecla = (document.all) ? e.keyCode : e.which;
    if (tecla == 8) return true;
    var patron = /[A-Za-z0-9ñÑ]/; // Caracteres permitidos
    var te = String.fromCharCode(tecla);
    return patron.test(te);
  }
}
